// Week 7 / Day 2 — Время, услуги и план / Time, Services and Plan
// Solid Grade 6 math + RU Grade 3–4.

export const maxWeek7Day2 = {
  id: 'max-week-7-day-2',
  studentId: 'max',
  weekId: 'week-7',
  dayId: 'day-2',
  title: 'Время, услуги и план / Time, Services and Plan',
  shortTitle: 'Время и планы / Time and Plans',
  theme:
    'Макс анализирует время выполнения услуг и сравнивает два плана. / Max analyses service time and compares two plans.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни ведёт Макса через процент плана, сравнение планов A и B, обратный процент и таблицу дней. / Nimny walks Max through plan percent, A vs B, inverse percent and a daily table.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: проценты плана, сравнение планов, обратный процент, анализ таблицы (Grade 6). / plan percent, plan comparison, inverse percent, table analysis.',
    'Слой 2. Русский / Layer 2. Russian: части речи, исправление, безударные. / parts of speech, correction, unstressed.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о плане и качестве + план + 4 предложения.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: скорость vs качество услуги.',
    'Слой 5. Практика: свой сервис-план из 4 задач с временем. / Practical: own 4-task service plan with times.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'услуга / service', definition: 'работа для другого человека / work done for another person' },
    { term: 'план / plan', definition: 'список задач и времени / a list of tasks and time' },
    { term: 'сравнение / comparison', definition: 'выясняем, где больше и где меньше / find which is more/less' },
    { term: 'обратный процент / inverse percent', definition: 'находим целое по части и проценту / find whole from part + percent' },
    { term: 'качество / quality', definition: 'насколько работа сделана точно / how accurately the work is done' },
    { term: 'проверка / check', definition: 'этап поиска ошибок / step of finding errors' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Процент выполнения плана / Percent of plan',
      prompt: 'Команда планировала 240 минут полезной работы за неделю. К среде — 150. Процент выполнения и процент остатка? / 150/240 = ?; missing % ?',
      helper: 'Часть ÷ целое × 100%. / Part / whole × 100%.',
      answer: 'Выполнено 62.5%; осталось 37.5%. / 62.5% done; 37.5% left.', unit: '%' },
    { id: 'q2', type: 'math', title: 'Два плана / Two plans',
      prompt: 'План A: 4 × 18 мин. План B: 6 × 13 мин. Какой дольше и на сколько? / Which is longer and by how much?',
      helper: 'Умножь и сравни. / Multiply and compare.',
      answer: 'B дольше на 6 мин (78 vs 72). / B is 6 min longer.', unit: 'мин / min' },
    { id: 'q3', type: 'math', title: 'Обратный процент / Inverse percent',
      prompt: 'Команда сделала 75% плана — это 180 минут. Сколько минут в полном плане? / 75% = 180 → whole?',
      helper: '180 ÷ 0.75. / Divide by percent.',
      answer: '240 минут. / 240 minutes.', unit: 'мин / min' },
    { id: 'q4', type: 'math', title: 'Сложный график / Weekly table',
      prompt: 'Пн 35, Вт 50, Ср 45, Чт 60, Пт 50 минут. Найди: 1) общее; 2) среднее; 3) медиану; 4) день с самым большим ростом по сравнению с предыдущим. / Totals + max jump.',
      helper: 'Сортировка для медианы; изменения по дням. / Sort + day-to-day deltas.',
      answer: 'Всего 240; среднее 48; медиана 50; максимум +15 (Пн→Вт или Ср→Чт). / 240 / 48 / 50 / +15.', unit: '' },
    { id: 'q5', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'услуга / service' },
        { id: 'w2', text: 'аккуратный / neat' },
        { id: 'w3', text: 'планировать / to plan' },
        { id: 'w4', text: 'качество / quality' },
        { id: 'w5', text: 'внимательный / attentive' },
        { id: 'w6', text: 'сравнивать / to compare' }
      ] },
    { id: 'q6', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «харошый план учитывает время, качиство и проверку». / Rewrite without mistakes.',
      placeholder: 'Хороший план... / A good plan...' },
    { id: 'q7', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «План, время, качество» на печатном листе. Запиши главную мысль, план из 3 пунктов и 4 предложения. / Read; main idea + plan + 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q8', type: 'text', title: 'Логика: скорость vs качество / Logic: speed vs quality',
      prompt: 'Что лучше — сделать услугу быстро или аккуратно? Когда скорость мешает качеству? 2–4 предложения. / When does speed hurt quality?',
      placeholder: 'Скорость помогает... / Speed helps...' },
    { id: 'q9', type: 'essay', title: 'Мой сервис-план из 4 задач / My 4-task service plan',
      prompt: 'Составь план из 4 задач с временем и порядком проверки. Общее ≤ 90 минут. / 4-task plan with time and check order; total ≤ 90.',
      minSentences: 4, maxSentences: 8, placeholder: '1) ______ (____ мин) 2) ______ (____ мин)...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 7, День 2». / Heading.',
    'Слой 1. Математика: q1–q4. / Math.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: скорость vs качество. / Logic.',
    'Слой 5. Практика: сервис-план 4 задач. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 7, День 2 / Week 7, Day 2',
    subtitle: 'Время, услуги и план / Time, Services and Plan',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: сервис-план / Practical: service plan — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: проценты, сравнение планов, обратный процент, таблицы. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) 150 ÷ 240 = ____ = ____%. Остаток: 100% − ____% = ____%. / Percent + remainder.',
          '2) A: 4 × 18 = ____ мин. B: 6 × 13 = ____ мин. Разница: ____ − ____ = ____ мин. / Compare plans.',
          '3) 75% = 180 мин → 180 ÷ 0.75 = ____ мин (полный план). / Inverse percent.',
          '4) 35 + 50 + 45 + 60 + 50 = ____ мин. Среднее = ____ ÷ 5 = ____. Сортировка: ____, ____, ____, ____, ____. Медиана = ____. Изменения: +15, ____, +15, ____. Самый большой рост = +15. / Weekly stats.',
          '5) Проверка / Check: 62.5% + 37.5% = ____%? / Verify.',
          '6) Проверка / Check: 4 × 18 + 6 = 6 × 13? / Verify plans.',
          '7) Optional / Доп.: если план 480 мин, а сделали 300, процент = ____%. / Extra.',
          '8) Optional / Доп.: 62.5% от 240 = ____ мин. / Extra.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: части речи по вопросу; безударные проверяем ударением. / Parts of speech + unstressed.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: услуга, план, качество, проверка, аккуратность, время, задача, порядок.',
          'Части речи / Parts of speech: услуга, аккуратный, планировать, качество, внимательный, сравнивать — раздели.',
          'Исправь ошибки / Fix mistakes: «харошый план учитывает время, качиство и проверку».',
          'Мини-диктант / Mini-dictation: «Хороший план учитывает время, качество и проверку».',
          'Орфограмма дня / Spelling rule: безударные проверяемые + буква Ч/Щ на письме. / Unstressed + Ch/Shch.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «План, время, качество» / Text: Хорошая услуга — это не только скорость. План должен учитывать три вещи: сколько минут займёт задача, каким будет качество и как мы проверим ошибки. Если пропустить проверку, услуга получится быстрее, но с ошибками; их придётся исправлять снова. Поэтому проверка — это не потеря времени, а часть услуги. Тогда план становится честным и результат — надёжным. / Good service is not only speed. A plan must account for time, quality and the check step. Skipping the check makes work faster but broken; you fix it later. Check is part of the service, not lost time.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о плане / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Сравни две услуги: A — быстро без проверки; B — чуть дольше, но с проверкой. / A (fast, no check) vs B (slower, with check).' },
        { type: 'list', items: [
          'A: 30 мин работы + 0 мин проверки = ____ мин. / A total.',
          'B: 30 мин работы + 10 мин проверки = ____ мин. / B total.',
          'Если у A потом 3 исправления по 5 мин, общее время A стало = ____ мин. / A after fixes.',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: проверка добавляет минуты, но экономит переделки. / Check saves rework.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: сервис-план / Layer 5. Practical Knowledge: service plan', blocks: [
        { type: 'text', text: 'Составь план из 4 задач с временем и проверкой. Это не реальная услуга, а учебный план. / Not a real service; learning plan only.' },
        { type: 'list', items: [
          'Задача 1 / Task 1: ______________________________ (____ мин).',
          'Задача 2 / Task 2: ______________________________ (____ мин).',
          'Задача 3 / Task 3: ______________________________ (____ мин).',
          'Задача 4 / Task 4: ______________________________ (____ мин).',
          'Проверка / Check: ____ мин.',
          'Всего / Total: ____ мин (≤ 90).',
          'Порядок проверки / Check order: 1 → 2 → 3 → 4 (кратко / briefly).'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что я понял про план услуги / What I learned about a service plan: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за обратный процент и таблицу / Bonus for inverse percent + table: +1 ☐',
          'Бонус за сервис-план с проверкой / Bonus for a checked plan: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: 150/240 = 62.5% (остаток 37.5%); A=72, B=78, разница 6; обратный 180/0.75 = 240; ряд 35/50/45/60/50 → 240/48/50, max +15. Русский Grade 3–4. / Solid Grade 6 + Grade 3–4 Russian.',
    mathGoal: 'q1: 62.5% и 37.5%. q2: B дольше на 6 мин. q3: 240 мин. q4: 240 / 48 / 50; max +15. / Listed.',
    russianGoal: 'Существительные: услуга, качество. Глаголы: планировать, сравнивать. Прилагательные: аккуратный, внимательный. / Correct sorting.',
    readingWritingGoal: 'Главная мысль: проверка — часть услуги, а не потеря времени. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Сервис-план 4 задач ≤ 90 мин с проверкой. / 4-task plan ≤ 90 min with check.',
    check: [
      'Q1: 62.5% и 37.5%.',
      'Q2: B дольше на 6 мин.',
      'Q3: 240 мин (обратный процент).',
      'Q4: 240 / 48 / 50; +15.',
      'Части речи разобраны. / Parts of speech.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Логика скорость vs качество. / Speed vs quality.',
      'Сервис-план с проверкой. / Plan with check.'
    ],
    answerKey: [
      { taskId: 'q1', answer: '150 ÷ 240 = 0.625 = 62.5%; остаток 100% − 62.5% = 37.5%. / 62.5%; 37.5%.' },
      { taskId: 'q2', answer: 'A = 72; B = 78; B − A = 6 мин. / B longer by 6 min.' },
      { taskId: 'q3', answer: '75% = 0.75; 180 ÷ 0.75 = 240. / 240 minutes.' },
      { taskId: 'q4', answer: 'Сумма 240; среднее 48; сортировка 35/45/50/50/60; медиана 50; изменения +15, −5, +15, −10; максимум +15 (Пн→Вт или Ср→Чт).' },
      { taskId: 'q5', answer: 'Существительные: услуга, качество. Глаголы: планировать, сравнивать. Прилагательные: аккуратный, внимательный.' },
      { taskId: 'q6', answer: 'Хороший план учитывает время, качество и проверку.' },
      { taskId: 'q7', answer: 'Главная мысль: проверка — часть услуги. План: 1) время; 2) качество; 3) проверка. 4 предложения — открытый ответ.' },
      { taskId: 'q8', answer: '2–4 предложения: скорость помогает, но без проверки появляются ошибки; пример: A(30 мин) + 3×5 мин исправлений = 45; B(30 + 10 проверки) = 40. / Reasoning + example.' },
      { taskId: 'q9', answer: 'Открытый ответ: 4 задачи + проверка ≤ 90 мин. / Open answer.' }
    ],
    spellingCheck: 'Части речи + безударные правильно. / Parts of speech + vowels.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Что чаще ломает план услуги? / What breaks a service plan?',
      'Как ты понимаешь, что проверка помогла? / How do you know the check helped?',
      'Что важнее — скорость или проверка? / Speed or check?',
      'Как ты сделаешь план короче без потери качества? / Shorter without losing quality?'
    ],
    ifEasy: 'Усложни: пересчитай процент, если сделано 200 из 240. / Extend: 200/240 percent.',
    ifDifficult: 'Оставь q1 и q3. / Keep q1 and q3.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'inverse-table', label: 'Бонус за обратный процент и таблицу / Bonus for inverse percent + table', amount: 1 },
      { id: 'checked-plan', label: 'Бонус за план с проверкой / Bonus for a checked plan', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q7', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-7', dayId: 'day-1' },
  nextLessonId: 'max-week-7-day-3'
};

export default maxWeek7Day2;
